export default __webpack_public_path__ + "static/media/bg8.fae376de.jpg";